'use es6';

export const DEFAULT = 0;
export const DIALOG = 1;
export const IDE = 2;